<template>
  <section :class="class" class="flex flex-col gap-2">
    <label v-if="!noLabel" class="text-sm font-semibold" :class="{ required: question.required, optional: !question.required }">
      {{ question.label }}
    </label>
    <div class="flex flex-row flex-wrap gap-4 p-2 w-full justify-center">
      <rpm-input
        v-for="option in question.options"
        type="radio"
        :label="option.label"
        :value="option.label"
        v-bind="$attrs"
        class="items-center"
      ></rpm-input>
    </div>
  </section>
</template>

<script>
export default {
  name: "RadioAnswer",
  data(){
    return {};
  },
  props: {
    question: {
      type: Object,
      required: true
    },
    noLabel: {
      type: Boolean,
      default: false
    },
    class: {
      type: [Object, String, Array],
      default: ''
    }
  },
};
</script>
